export default __webpack_public_path__ + "static/media/your-final-score.76284cc1.png";